// src/CalendarIcon.js
import React from "react";

const CalendarIcon = ({ size = 32, color = "#1976d2" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        style={{ display: "block" }}
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect x="3" y="5" width="18" height="16" rx="4" fill={color} />
        <rect x="3" y="9" width="18" height="12" rx="2" fill="#fff" />
        <rect x="7" y="13" width="2" height="2" rx="1" fill={color} />
        <rect x="11" y="13" width="2" height="2" rx="1" fill={color} />
        <rect x="15" y="13" width="2" height="2" rx="1" fill={color} />
        <rect x="7" y="17" width="2" height="2" rx="1" fill={color} />
        <rect x="11" y="17" width="2" height="2" rx="1" fill={color} />
        <rect x="15" y="17" width="2" height="2" rx="1" fill={color} />
        <rect x="7" y="5" width="2" height="4" rx="1" fill="#fff" />
        <rect x="15" y="5" width="2" height="4" rx="1" fill="#fff" />
    </svg>
);

export default CalendarIcon;